import { formatToDOMAttrs, getMetadata } from '../libs';
import { FLAG, FORMAT_TYPE, SYL_TAG } from './const';
var createElement = function (tagName) {
    var container = document.createElement(tagName);
    container.setAttribute(SYL_TAG, 'true');
    return container;
};
var createCardDOM = function () { return createElement('div'); };
var createInlineCardDOM = function () { return createElement('syl-inline'); };
// provide default `toDOM` according to `tagName`, `attrs` and `content`
var createWrapperDOM = function (tagName, attrs, hasContent) {
    if (attrs === void 0) { attrs = {}; }
    if (hasContent === void 0) { hasContent = false; }
    var pDOM = [tagName, formatToDOMAttrs(attrs)];
    if (hasContent)
        pDOM[2] = 0;
    return pDOM;
};
var createMaskDOM = function () { return document.createElement('mask'); };
var createTemplDOM = function () {
    var dom = document.createElement('templ');
    dom.setAttribute('style', 'display: none;');
    return dom;
};
var checkType = function (current, type) {
    var flag = getMetadata(FLAG, current);
    return Boolean(flag) && Boolean(flag & type);
};
var getSchemaType = function (Ctor) { return getMetadata(FLAG, Ctor); };
var isCardSchema = function (Ctor) { return checkType(Ctor, FORMAT_TYPE.CARD); };
var isInlineSchema = function (Ctor) { return checkType(Ctor, FORMAT_TYPE.INLINE); };
var isBlockSchema = function (Ctor) { return checkType(Ctor, FORMAT_TYPE.BLOCK); };
export { createCardDOM, createInlineCardDOM, createMaskDOM, createTemplDOM, createWrapperDOM, getSchemaType, isBlockSchema, isCardSchema, isInlineSchema, };
//# sourceMappingURL=utils.js.map